import React, { useEffect, useState } from 'react';
import './Table.css';

function Table({ table, onUpdate, onMergedUpdate, embedMode = false, onEmbedSelect, isEmbedSource = false }) {
  const [showInput, setShowInput] = useState(false);
  const [guestCount, setGuestCount] = useState(table.guests);
  const [reservationName, setReservationName] = useState(table.reservationName || '');
  const [reservationTime, setReservationTime] = useState(table.reservationTime || '');

  useEffect(() => {
    setGuestCount(table.guests);
    setReservationName(table.reservationName || '');
    setReservationTime(table.reservationTime || '');
  }, [table.guests, table.reservationName, table.reservationTime]);

  useEffect(() => {
    if (embedMode) {
      setShowInput(false);
    }
  }, [embedMode]);

  const normalizedReservationName = (reservationName || '').trim();
  const normalizedReservationTime = (reservationTime || '').trim();

  const handleSave = async () => {
    if (table.isMerged && onMergedUpdate) {
      await onMergedUpdate(table.groupId, guestCount, normalizedReservationName, normalizedReservationTime);
    } else {
      await onUpdate(table.id, guestCount, normalizedReservationName, normalizedReservationTime);
    }
    setShowInput(false);
  };

  const handleClearReservation = async () => {
    setGuestCount(0);
    setReservationName('');
    setReservationTime('');

    if (table.isMerged && onMergedUpdate) {
      await onMergedUpdate(table.groupId, 0, '', '');
    } else {
      await onUpdate(table.id, 0, '', '');
    }
    setShowInput(false);
  };

  const handleCancel = () => {
    setGuestCount(table.guests);
    setReservationName(table.reservationName || '');
    setReservationTime(table.reservationTime || '');
    setShowInput(false);
  };

  const isOccupied = table.guests > 0;
  const displayNumber = table.displayNumber || `#${table.number}`;
  const hasReservationInfo = Boolean((table.reservationName || '').trim() || (table.reservationTime || '').trim());
  const reservationDisplay = [table.reservationName, table.reservationTime].map((value) => (value || '').trim()).filter(Boolean).join(' - ');

  return (
    <>
      <div
        className={`floor-table table-${table.type} ${isOccupied ? 'occupied' : 'free'} ${hasReservationInfo ? 'reserved' : ''} ${table.groupId ? 'grouped' : ''} ${table.isMerged ? 'is-merged' : ''} ${isEmbedSource ? 'embed-source' : ''}`}
        style={{
          left: `${table.x}px`,
          top: `${table.y}px`
        }}
        onClick={() => {
          if (embedMode) {
            if (onEmbedSelect) onEmbedSelect(table.id);
            return;
          }
          setShowInput(true);
        }}
      >
        {hasReservationInfo && (
          <div className="table-reservation-chip" title={reservationDisplay}>
            {reservationDisplay}
          </div>
        )}
        <div className="table-inner">
          <div className="table-capacity">{table.capacity}P</div>
          <div className={`table-number ${table.isMerged ? 'merged-number' : ''}`}>{displayNumber}</div>
        </div>
      </div>

      {showInput && (
        <div className="modal-overlay" onClick={handleCancel}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Table {displayNumber}</h3>
            <p className="capacity-info">Capacité: {table.capacity} personnes</p>
            
            <div className="input-group">
              <label>Nom de la réservation:</label>
              <input
                type="text"
                value={reservationName}
                onChange={(e) => setReservationName(e.target.value)}
                placeholder="Ex: Martin"
                className="input-text"
              />
            </div>

            <div className="input-group">
              <label>Heure d'arrivée:</label>
              <input
                type="time"
                value={reservationTime}
                onChange={(e) => setReservationTime(e.target.value)}
                className="input-text"
              />
            </div>

            <div className="input-group">
              <label>Nombre de personnes:</label>
              <div className="input-controls">
                <button 
                  onClick={() => setGuestCount(Math.max(0, guestCount - 1))}
                  className="btn-minus"
                >
                  -
                </button>
                <input
                  type="number"
                  min="0"
                  max={table.capacity}
                  value={guestCount}
                  onChange={(e) => setGuestCount(Math.min(table.capacity, Math.max(0, parseInt(e.target.value) || 0)))}
                  className="input-number"
                />
                <button 
                  onClick={() => setGuestCount(Math.min(table.capacity, guestCount + 1))}
                  className="btn-plus"
                >
                  +
                </button>
              </div>
            </div>

            <div className="modal-buttons">
              <button onClick={handleClearReservation} className="btn-clear">Retirer Réservation</button>
              <button onClick={handleSave} className="btn-save">Enregistrer</button>
              <button onClick={handleCancel} className="btn-cancel">Annuler</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Table;
